import { render, staticRenderFns } from "./agShareList.vue?vue&type=template&id=0237cb01&scoped=true"
import script from "./agShareList.vue?vue&type=script&lang=js"
export * from "./agShareList.vue?vue&type=script&lang=js"
import style0 from "./agShareList.vue?vue&type=style&index=0&id=0237cb01&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0237cb01",
  null
  
)

export default component.exports